import { getRouteApi } from '@tanstack/react-router';
import { useCallback } from 'react';

import { definedSearchParams } from '@/lib/search-params';

import { PromotionDetailScreen } from './PromotionDetailScreen';
import type { PromotionDetailSearch } from './promotions-search';

const route = getRouteApi('/promotions/$campaignId');

export function PromotionDetailRoute() {
  const { campaignId } = route.useParams();
  const search = route.useSearch();
  const navigate = route.useNavigate();

  const onSearchChange = useCallback(
    (next: PromotionDetailSearch) => {
      void navigate({ replace: true, search: () => definedSearchParams(next) });
    },
    [navigate],
  );

  const onOpenUser = useCallback(
    (userId: string) => {
      void navigate({ to: '/users/$userId', params: { userId }, search: { tab: 'profile' } });
    },
    [navigate],
  );

  return (
    <PromotionDetailScreen
      // Keyed so the redemptions pager's cursor history does not carry over to another campaign.
      key={campaignId}
      campaignId={campaignId}
      search={search}
      onSearchChange={onSearchChange}
      onOpenUser={onOpenUser}
    />
  );
}
